import { isPlainObject } from 'shared/utils/object';

/**
 * Wire format of requests answered by a `ChannelServer`. Events keep the
 * `{ type, data }` shape; requests are told apart by `kind`.
 */
export enum RequestMessageKind {
  request = 'channel-request',
  /** Sent by the server on receipt, before the handler runs. */
  acknowledgement = 'channel-request-acknowledgement',
  response = 'channel-response',
}

export interface ChannelRequestMessage<TData = unknown> {
  kind: RequestMessageKind.request;
  method: string;
  requestId: string;
  data: TData;
}

export interface ChannelAcknowledgementMessage {
  kind: RequestMessageKind.acknowledgement;
  requestId: string;
}

export interface ChannelErrorPayload {
  message: string;
  messageId: string | null;
  /** The original error, as far as structured clone keeps it. */
  cause?: unknown;
}

export type ChannelResponseMessage<TData = unknown> =
  | { kind: RequestMessageKind.response; requestId: string; data: TData }
  | { kind: RequestMessageKind.response; requestId: string; error: ChannelErrorPayload };

function isKind(message: unknown, kind: RequestMessageKind): boolean {
  return isPlainObject(message) && message.kind === kind;
}

export function isChannelRequestMessage(message: unknown): message is ChannelRequestMessage {
  return isKind(message, RequestMessageKind.request);
}

export function isChannelAcknowledgementMessage(message: unknown): message is ChannelAcknowledgementMessage {
  return isKind(message, RequestMessageKind.acknowledgement);
}

export function isChannelResponseMessage(message: unknown): message is ChannelResponseMessage {
  return isKind(message, RequestMessageKind.response);
}
